import React, { FunctionComponent } from 'react';
import Breadcrumb, { BreadcrumbItem } from '../../../components/breadcrumb/Breadcrumb';
import * as styles from './PageLayoutBreadcrumb.style';

export interface PageLayoutBreadcrumbProps {
  items: BreadcrumbItem[],
}

const PageLayoutBreadcrumb: FunctionComponent<PageLayoutBreadcrumbProps> = ({
  items,
  ...rest
}) => (
  <div
    css={styles.breadcrumb}
    {...rest}
  >
    <Breadcrumb
      inline={false}
      items={[
        {
          label: 'Dove.it',
          urlObject: {
            url: '/',
            as: '/',
          },
        },
        ...items,
      ]}
    />
  </div>
);

export default PageLayoutBreadcrumb;
